function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { Component } from 'react';
import { getUiOptions, getDefaultFormState } from "../Schema/utils";

class FieldAnnotateImage extends Component {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "onChange", formData => {
      const _this$props = this.props,
            schema = _this$props.schema,
            defaultFormData = _this$props.defaultFormData;
      formData = getDefaultFormState(schema, _extends({}, defaultFormData, {}, formData));

      const newFormData = _extends({}, formData);

      if (this.props.onChange) {
        this.props.onChange(newFormData);
      }
    });

    _defineProperty(this, "getUiSchema", () => {
      const _this$props2 = this.props,
            formData = _this$props2.formData,
            schema = _this$props2.schema,
            uiSchema = _this$props2.uiSchema,
            defaultUiSchema = _this$props2.defaultUiSchema;
      return _extends({}, defaultUiSchema, {}, uiSchema);
    });

    _defineProperty(this, "getField", () => {
      const uiSchema = this.getUiSchema();
      return _extends({}, this.props, {
        uiSchema: uiSchema
      });
    });
  }

  render() {
    const _this$getField = this.getField(),
          schema = _this$getField.schema,
          uiSchema = _this$getField.uiSchema,
          formData = _this$getField.formData,
          registry = _this$getField.registry;

    const ObjectField = registry.fields.ObjectField;
    return React.createElement(ObjectField, _extends({}, this.props, {
      schema: schema,
      uiSchema: uiSchema,
      formData: formData,
      onChange: this.onChange
    }));
  }

}

_defineProperty(FieldAnnotateImage, "defaultProps", {
  defaultFormData: {
    "mediaId": undefined,
    "media": {
      "mediaType": undefined
    },
    "imageAnnotations": []
  },
  defaultUiSchema: {
    "ui:layout": "annotateImage",
    "ui:format": "2:1",
    "ui:options": {
      "hideable": true,
      "deletable": true
    },
    "ui:preview": {
      "select": {
        "mediaId": "mediaId",
        "media": "media",
        "imageAnnotations": "imageAnnotations"
      }
    },
    "ui:buttons": [{
      "type": "upload"
    }],
    "ui:fieldset": ["imageAnnotations"],
    "imageAnnotations": {
      "ui:title": "Markører",
      "ui:preview": {
        "select": {
          "title": "title"
        },

        prepare({
          formData
        }) {
          let title;

          if (formData && formData.length) {
            title = formData.length + " markører";
          } else {
            title = "Klikk på bilde for å legge til";
          }

          return {
            title: title
          };
        }

      },
      "ui:options": {
        "sortable": true
      },
      "items": {
        "ui:layout": "module",
        "ui:preview": {
          "select": {
            "title": "title"
          },

          prepare({
            formData
          }) {
            const index = formData && formData._index && formData._index + 1 || 1;
            const title = formData && formData.title;
            return {
              title: index + ". " + title
            };
          }

        },
        "ui:options": {
          "editable": true
        },
        "top": {
          "ui:hidden": true
        },
        "left": {
          "ui:hidden": true
        },
        "x": {
          "ui:hidden": true
        },
        "y": {
          "ui:hidden": true
        },
        "radius": {
          "ui:widget": "range"
        },
        "title": {
          "ui:title": "Tittel"
        },
        "description": {
          "ui:title": "Beskrivelse",
          "ui:widget": "textarea"
        }
      }
    }
  }
});

export default FieldAnnotateImage;